import { IAutomationObject } from '../../types'
import { OperationState } from "../OperationState";

export interface IFireDamperOpenClose extends IAutomationObject {
    state: OperationState;
    isOpen: boolean;
    isClose: boolean;
    errNoPos: number;
    errClosed: number;
    errSum: boolean;
    onValueChanged: any;
}

export const schema = 'AutomationApps.Devices.FireDampers.FireDamperOpenClose';